/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountInfoResponse } from '../../models/account-info-response';

export interface GetSessionAccountInfo$Params {
  projections?: string;
}

export function getSessionAccountInfo(http: HttpClient, rootUrl: string, params?: GetSessionAccountInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountInfoResponse>> {
  const rb = new RequestBuilder(rootUrl, getSessionAccountInfo.PATH, 'get');
  if (params) {
    rb.query('projections', params.projections, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountInfoResponse>;
    })
  );
}

getSessionAccountInfo.PATH = '/api/v2/session/account-info';
